export default __webpack_public_path__ + "static/media/fourBars.7cbef49b.svg";